<template>
  <div class="proposal__wrap">
    <div class="section shadow filter__wrap">
      <div style="margin-bottom: 10px">
        <el-radio-group v-model="table.params.part_status" @change="handleTabs">
          <el-radio-button :label="0">全部</el-radio-button>
          <el-radio-button :label="1"
            >待审核({{ table.checking_total }})</el-radio-button
          >
          <el-radio-button :label="3"
            >审核通过({{ table.pass_total }})</el-radio-button
          >
          <el-radio-button :label="2"
            >审核拒绝({{ table.refuse_total }})</el-radio-button
          >
        </el-radio-group>
      </div>
      <div style="margin-bottom: 10px" v-if="table.params.part_status == 3">
        <el-radio-group
          v-model="table.params.process_status"
          @change="handleTabs"
          size="mini"
        >
          <el-radio-button :label="1">招聘中({{ table.process_total }})</el-radio-button>
          <el-radio-button :label="2">已下架({{ table.over_total }})</el-radio-button>
        </el-radio-group>
      </div>
      <div class="flex" style="margin-bottom: 10px">
        <el-form
          ref="elFormDom"
          inline
          :model="table.params"
          @submit.native.prevent="handleSearch"
        >
          <el-form-item label="企业名称" prop="company_id">
            <el-select
              v-model="table.params.company_id"
              size="mini"
              filterable
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in companyList_"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="岗位类型" prop="categoryList">
            <el-cascader
              v-model="table.params.categoryList"
              :options="categoryArr"
              size="mini"
              clearable
              :props="{
                emitPath: true,
                checkStrictly: true,
                value: 'id',
                label: 'name',
              }"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="结算周期" prop="part_settlement_type">
            <el-select
              clearable
              v-model.trim="table.params.part_settlement_type"
              placeholder="请输入"
              size="mini"
            >
              <el-option label="日结" :value="1"></el-option>
              <el-option label="周结" :value="2"></el-option>
              <el-option label="月结" :value="3"></el-option>
              <el-option label="项目结" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="招聘方式" prop="part_time_type">
            <el-select
              clearable
              v-model="table.params.part_time_type"
              placeholder="请输入"
            >
              <el-option label="企业直招" :value="1"></el-option>
              <el-option label="平台代招" :value="2"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="状态" prop="publish_status" v-if="table.params.part_status == 3">
            <el-select
              clearable
              v-model="table.params.publish_status"
              placeholder="请输入"
              size="mini"
            >
              <el-option label="招聘中" :value="1" v-if="table.params.process_status == 1"></el-option>
              <el-option label="已招满" :value="2"></el-option>
              <el-option label="已过期" :value="3"></el-option>
              <el-option v-if="table.params.process_status == 2" label="已停招" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="onSearch"
              >查询
            </el-button>
            <el-button icon="el-icon-refresh-right" @click="reset"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <el-row>
        <el-button type="primary" size="mini" @click="addTo()"
          >发布代招</el-button
        >
        <el-button v-if="table.params.part_status == 3 && table.params.process_status == 1" type="primary" size="mini" @click="batchOperationPartFun()"
          >批量停招</el-button
        >
      </el-row>
    </div>
    <!-- 表格 -->
    <div class="table__wrap">
      <VTable
        ref="tableDom"
        :key="table.params.part_status + '_' + table.params.process_status"
        :showSelect="table.params.part_status == 3 && table.params.process_status == 1"
        :selectable="() => true"
        has-pagionation
        title=""
        addText="添加"
        :field="getField()"
        :loading="table.loading"
        :data="table.data"
        :page="table.params.page"
        :pageSize="table.params.count"
        :total="table.total"
        :tree-props="{ children: 'children', hasChildren: 'has_child' }"
        :hasPagionation="true"
        :default-expand-all="true"
        :showOverflowTooltip="true"
        @handleSelectionChange="handleSelectionChange"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      >
        <template v-slot:show_status="{ row }">
          {{
            { 1: "待审核", 2: "审核拒绝", 3: "招聘中", 4: "已下架" }[
              row.part_status
            ]
          }}
        </template>
        <template v-slot:publish_status="{ row }">
          <!-- {{
            { 1: "招聘中", 2: "已招满", 3: "已过期",}[
              row.publish_status
            ]
          }} -->
          <span v-if="table.params.process_status == 1">
            {{
              { 1: "招聘中", 2: "已招满", 3: "已过期",}[
              row.publish_status
            ]
            }}
          </span>
          <span v-if="table.params.process_status == 2">
            {{
              { 2: "已招满", 3: "已过期",4:'已停招'}[
              row.publish_status
            ]
            }}
          </span>
        </template>
        <template v-slot:part_settlement_type="{ row }">
          <div>
            {{
              `${
                { 1: "日结", 2: "周结", 3: "月结", 4: "项目结" }[
                  row.part_settlement_type
                ]
              }`
            }}
          </div>
        </template>
        <template v-slot:salary="{ row }">
          <div>
            {{
              `${row.salary}元/${
                { 1: "小时", 2: "日", 3: "月" }[row.salary_type]
              }`
            }}
          </div>
        </template>
        <template v-slot:part_time_type="{ row }">
          <div>
            {{ { 1: "企业直招", 2: "平台代招" }[row.part_time_type] }}
          </div>
        </template>
        <template v-slot:miss_total="{ row }">
          <el-button type="text" @click="viewWaitPerson(row)">{{
            row.miss_total
          }}</el-button>
        </template>
        <template v-slot:view_count="{ row }">
          <el-button
            type="text"
            @click="viewreadEdAndSign(row, '看过人数', 1)"
            >{{ row.view_count }}</el-button
          >
        </template>
        <template v-slot:send_count="{ row }">
          <el-button
            type="text"
            @click="viewreadEdAndSign(row, '报名人数', 3)"
            >{{ row.send_count }}</el-button
          >
        </template>
        <template v-slot:action="{ row }">
          <!-- 1: "待审核", 2: "审核拒绝", 3: "审核通过" -->
          <el-button
            type="text"
            size="mini"
            v-if="row.part_status == 1"
            @click="showDetail(row, '审核岗位')"
            >审核</el-button
          >
          <el-button
            v-if="row.part_status != 1"
            type="text"
            size="mini"
            @click="showDetail(row, '查看')"
            >查看</el-button
          >
          <el-button
            type="text"
            size="mini"
            @click="operateRow(row)"
            v-if="row.part_status == 3 && row.show_status == 3"
            >停招</el-button
          >
          <el-button
            type="text"
            size="mini"
            @click="operateRow(row)"
            v-if="row.part_status == 3 && row.show_status == 4"
            >开启</el-button
          >
          <el-button
            @click="editRow(row)"
            type="text"
            size="mini"
            v-if="row.part_status == 3"
            >修改</el-button
          >
        </template>
      </VTable>
    </div>

    <detail ref="detail" @update="getTable"></detail>
    <edit ref="editRef" @refresh="getTable"></edit>
    <waitPersonDialog ref="waitPersonDialogRef" @refresh="getTable"></waitPersonDialog>
    <readEdAndSignDialog ref="readEdAndSignDialogRef"></readEdAndSignDialog>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import Detail from "./components/Detail.vue";
import { mixinTable } from "@/mixins/table.js";
import edit from "./components/edit.vue";
import waitPersonDialog from "./components/waitPersonDialog.vue";
import readEdAndSignDialog from "./components/readEdAndSignDialog.vue";
export default {
  name: "agentJobList",
  mixins: [mixinTable],
  components: {
    VTable,
    Detail,
    edit,
    waitPersonDialog,
    readEdAndSignDialog,
  },
  data() {
    return {
      part_time_amounts: [],
      companyList_: [],
      field: [
        {
          name: "company_name",
          label: "企业名称",
          hidden: false,
          width: "150",
          showTooltip: true,
        },
        { name: "title", label: "岗位名称", hidden: false, width: "150" },
        { name: "part_time_type", label: "招聘方式", hidden: false },
        {
          name: "category_name",
          label: "岗位类型",
          hidden: false,
          width: "120",
        },
        { name: "salary", label: "薪资", hidden: false, width: "150" },
        { name: "part_settlement_type", label: "结算周期", hidden: false },
        { name: "total", label: "招聘人数", hidden: false },
        { name: "create_name", label: "联系人", hidden: false },
        { name: "create_account", label: "联系电话", hidden: false },
        { name: "show_status", label: "状态", hidden: false },
        { name: "create_time", label: "创建时间", hidden: false, width: "150" },
        {
          name: "action",
          label: "操作",
          width: "120",
          hidden: false,
          fixed: "right",
        },
      ],
      field1: [
        {
          name: "company_name",
          label: "企业名称",
          hidden: false,
          width: "150",
          showTooltip: true,
        },
        { name: "title", label: "岗位名称", hidden: false, width: "150" },
        { name: "part_time_type", label: "招聘方式", hidden: false },
        {
          name: "category_name",
          label: "岗位类型",
          hidden: false,
          width: "120",
        },
        { name: "salary", label: "薪资", hidden: false, width: "150" },
        { name: "part_settlement_type", label: "结算周期", hidden: false },
        { name: "total", label: "招聘人数", hidden: false },
        { name: "create_name", label: "联系人", hidden: false },
        {
          name: "create_account",
          label: "联系电话",
          hidden: false,
          width: "150",
        },
        { name: "create_time", label: "创建时间", hidden: false, width: "150" },
        {
          name: "action",
          label: "操作",
          width: "60",
          hidden: false,
          fixed: "right",
        },
      ],
      field2: [
        {
          name: "company_name",
          label: "企业名称",
          hidden: false,
          width: "150",
          showTooltip: true,
        },
        { name: "title", label: "岗位名称", hidden: false, width: "150" },
        { name: "part_time_type", label: "招聘方式", hidden: false },
        {
          name: "category_name",
          label: "岗位类型",
          hidden: false,
          width: "120",
        },
        { name: "salary", label: "薪资", hidden: false, width: "150" },
        { name: "part_settlement_type", label: "结算周期", hidden: false },
        { name: "total", label: "招聘人数", hidden: false },
        { name: "view_count", label: "看过人数", hidden: false },
        { name: "send_count", label: "报名人数", hidden: false },
        { name: "miss_total", label: "待招人数", hidden: false },
        { name: "create_name", label: "联系人", hidden: false },
        {
          name: "create_account",
          label: "联系电话",
          hidden: false,
          width: "150",
        },
        {
          name: "publish_status",
          label: "状态",
          hidden: false,
        },
        { name: "create_time", label: "创建时间", hidden: false, width: "150" },
        {
          name: "part_check_time",
          label: "审核时间",
          hidden: false,
          width: "160",
        },
        {
          name: "action",
          label: "操作",
          width: "120",
          hidden: false,
          fixed: "right",
        },
      ],
      field3: [
        {
          name: "company_name",
          label: "企业名称",
          hidden: false,
          width: "150",
          showTooltip: true,
        },
        { name: "title", label: "岗位名称", hidden: false, width: "150" },
        { name: "part_time_type", label: "招聘方式", hidden: false },
        {
          name: "category_name",
          label: "岗位类型",
          hidden: false,
          width: "120",
        },
        { name: "salary", label: "薪资", hidden: false, width: "150" },
        { name: "part_settlement_type", label: "结算周期", hidden: false },
        { name: "total", label: "招聘人数", hidden: false },
        { name: "create_name", label: "联系人", hidden: false },
        {
          name: "create_account",
          label: "联系电话",
          hidden: false,
          width: "150",
        },
        { name: "create_time", label: "创建时间", hidden: false, width: "150" },
        {
          name: "part_check_time",
          label: "审核时间",
          hidden: false,
          width: "120",
        },
        { name: "part_refuse_reason", label: "拒绝原因", hidden: false },
        {
          name: "action",
          label: "操作",
          width: "60",
          hidden: false,
          fixed: "right",
        },
      ],
      categoryArr: [],
      table: {
        loading: false,
        params: {
          company_id: "",
          part_settlement_type: "",
          part_status: 1,
          process_status: 1,
          publish_status:'',
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
        checking_total: 0,
        pass_total: 0,
        refuse_total: 0,
        process_total:0,
        over_total:0,
      },
      multipleTable:[],
    };
  },
  created() {
    this.getTable();
    this.getCategory();
    this.getCompanyList()
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleTable = val;
    },
    batchOperationPartFun() {
      if(this.multipleTable.length){
        this.$confirm("是否批量停招？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() =>{
          let params = {
            ids:this.multipleTable.map(item=>item.id).join(','),
            status:2,
          }
          this.$http.post("/admin/job/batchOperationPart",params).then((res) => {
            if (res.code === 1) {
              this.$message.success("操作成功！");
              this.table.params.page = 1;
              this.getTable();
            }
          })
        })
      }else {
        this.$message.warning("请选择数据！");
        return false;
      }
    },
    reset() {
      this.$refs.elFormDom.resetFields();
      this.table.params.page = 1;
      this.getTable();
    },
    onSearch() {
      this.table.params.page = 1;
      this.getTable();
    },
    getTable() {
      let params = {
        ...this.table.params,
        publish_status: this.table.params.part_status == 3 ? this.table.params.publish_status : '',
      }
      this.$http
        .get("/admin/job/partList", { params: params })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.table.total = res.data.total;
            this.table.checking_total = res.data.checking_total;
            this.table.pass_total = res.data.pass_total;
            this.table.refuse_total = res.data.refuse_total;
            this.table.over_total = res.data.over_total;
            this.table.process_total = res.data.process_total;
            this.part_time_amounts = res.data.part_time_amounts;
            this.multipleTable = [];
            this.$nextTick(() => {
              this.$refs.tableDom.$refs.multipleTable.doLayout();
            });
          }
        });
    },
    // 切换状态
    handleTabs() {
      this.table.params.page = 1;
      this.table.params.publish_status = '';
      this.table.data = [];
      this.getTable();
      this.$nextTick(() => {
        this.$refs.tableDom.resetTableHeight();
      });
    },
    getField() {
      if (this.table.params.part_status === 1) {
        return this.field1;
      } else if (this.table.params.part_status === 3) {
        return this.field2;
      } else if (this.table.params.part_status === 2) {
        return this.field3;
      } else {
        return this.field;
      }
    },
    // 查看
    showDetail(row, title) {
      let dom = this.$refs.detail;
      dom.toggle(true);
      dom.getDetail(row, title);
      dom = null;
    },
    addTo() {
      let dom = this.$refs.editRef;
      dom.getpart_time_amounts(this.part_time_amounts);
      dom.toggle(true);
      dom = null;
    },
    editRow(row) {
      let dom = this.$refs.editRef;
      dom.getpart_time_amounts(this.part_time_amounts);
      dom.toggle(true);
      dom.getDetail(row, "修改");
      dom = null;
    },
    viewWaitPerson(row) {
      let dom = this.$refs.waitPersonDialogRef;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    viewreadEdAndSign(row, desc, apiType) {
      let dom = this.$refs.readEdAndSignDialogRef;
      dom.toggle(true);
      let newRow = { ...row, desc, apiType };
      dom.getDetail(newRow);
      dom = null;
    },
    operateRow(row) {
      let st = row.show_status == 3 ? "停招" : "开启";
      const message = `
          <div style="line-height: 1.8;">
            <p style="margin: 0;">岗位名称: ${row.title}</p>
            <p style="margin: 0;">确定${st}招聘吗?</p>
          </div>
        `;
      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          this.$http
            .post("/admin/job/operationPart", { id: row.id })
            .then((res) => {
              if (res.code == 1) {
                this.getTable();
                this.$message.success("操作成功！");
              }
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
}
.proposal__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;

  .filter__wrap {
    padding: 10px;
    margin-bottom: 20px;
    // display: flex;
    // justify-content: space-between;
  }

  .table__wrap {
    flex: 1;
    padding: 0;
    box-sizing: border-box;
  }
}
</style>